import React, { useRef, useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header/Header";
import images from "../../../images";
import TimelineCommon from "../../../components/common/Timeline/TimelineCommon";
import { FormField } from "../../../components/common/Input/Input";
import Button from "../../../components/common/Button/Button";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import { useTranslation } from "react-i18next";
import { usePostTopUpMutation } from "../../../services/apiSlice";

const TopUp = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [postTopUp] = usePostTopUpMutation();

  const modalRef = useRef();
  const debounceTimerRef = useRef(null);

  const [modalContent, setModalContent] = useState(null);
  const [topUpAmount, setTopUpAmount] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [error, setError] = useState({
    bankAccount: "",
    topUpAmount: "",
  });
  const handleBack = () => {
    navigate(-1);
  };

  const debouncedSetWithdrawAmount = useCallback((value) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      setTopUpAmount(value);
    }, 10); // Trì hoãn 500ms
  }, []);
  const handleBankAccountChange = (e) => {
    const value = e.target.value;
    setError((prev) => ({ ...prev, bankAccount: "" }));

    if (value === "" || /^\d+$/.test(value)) {
      setBankAccount(value);
    }
  };

  const handleTopUpAmountChange = (e) => {
    const value = e.target.value;
    setError((prev) => ({ ...prev, topUpAmount: "" }));

    if (/^\d*\.?\d*$/.test(value)) {
      debouncedSetWithdrawAmount(value);
    }
  };
  const stepsData = [
    {
      title: t("profile.topUp.fromAccount"),
      content: (
        <div className="relative w-full">
          <FormField
            placeholder={"+65 1234 5678"}
            value={bankAccount}
            onChange={handleBankAccountChange}
            classNameInput="h-[42px] pr-[150px]"
          />
          <button className="absolute right-2 top-1/2 -translate-y-1/2">
            <img
              src={images.PayNowImage}
              alt="PayNow"
              className="w-[142px] h-[42px]"
            />
          </button>
          {error.bankAccount && (
            <p className="text-xs text-red-500 mt-1">{error.bankAccount}</p>
          )}
        </div>
      ),
      completed: !!bankAccount,
    },
    {
      title: t("profile.topUp.selectCurrency"),
      content: (
        <div className="flex items-center gap-2 border rounded px-3 py-2">
          <img src={images.FlagImage} className="w-4" alt="Currency icon" />
          <span className="text-gray-800">SGD</span>
        </div>
      ),
      completed: true,
    },
    {
      title: t("profile.topUp.topUpAmount"),
      content: (
        <div className="relative w-full">
          <FormField
            placeholder={"900"}
            value={topUpAmount}
            onChange={handleTopUpAmountChange}
            classNameInput="h-[42px] pr-[150px]"
          />
          {error.topUpAmount && (
            <p className="text-xs text-red-500 mt-1">{error.topUpAmount}</p>
          )}
        </div>
      ),
      completed: topUpAmount !== "",
    },
  ];

  const openTopUpModal = () => {
    // if (!bankAccount || !topUpAmount) {
    //   return;
    // }
    setError({
      bankAccount: "",
      topUpAmount: "",
    });
    let isValid = true;
    if (!bankAccount || bankAccount.trim() === "") {
      setError((prev) => ({
        ...prev,
        bankAccount: t("profile.topUp.pleaseEnterBankAccount"),
      }));
      isValid = false;
    }
    if (!topUpAmount || topUpAmount.trim() === "") {
      setError((prev) => ({
        ...prev,
        topUpAmount: t("profile.topUp.pleaseEnterTopUpAmount"),
      }));
      isValid = false;
    } else if (parseFloat(topUpAmount) <= 0) {
      setError((prev) => ({
        ...prev,
        topUpAmount: t("profile.topUp.amountMustBeGreaterThanZero"),
      }));
      isValid = false;
    }
    if (isValid) {
      setModalContent({
        title: t("profile.topUp.confirmTopUp"),
        content: (
          <>
            <span>Lorem ipsum dolor sit amet, consectetur</span>
            <div className="flex flex-col justify-center p-3 mt-4 w-full text-black bg-white  rounded-xl border border-solid border-stone-200 ">
              <div className="text-base leading-none">
                {t("profile.topUp.topUpAmount")}
              </div>
              <div className="flex justify-center gap-1.5 items-center self-start mt-3 text-xl font-bold w-full">
                <img
                  loading="lazy"
                  src={images.FlagImage}
                  className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
                  alt="Currency icon"
                />
                <div className="self-stretch my-auto">{topUpAmount} SGD</div>
              </div>
            </div>
          </>
        ),
        actions: (closeModal) => (
          <>
            <Button
              text={t("base.cancel")}
              className="flex-1 border text-neutral-500"
              onClick={closeModal}
            />
            <Button
              text={t("profile.topUp.topUp")}
              className="flex-1 bg-[#3F54DF] text-white"
              onClick={handleConfirmTopUp}
            />
          </>
        ),
      });
      modalRef.current?.openModal();
    }
  };

  const confirmTopUp = () => {
    setModalContent({
      title: t("profile.topUp.topUpSuccess"),
      content: (
        <>
          <p>Lorem ipsum dolor sit amet, consectetur</p>
          <div className="flex justify-center mt-4">
            <img src={images.WalletIcon} className="w-[80px] h-[80px]" alt="" />
          </div>
          <div className="flex flex-col justify-center p-3 mt-4 w-full text-black bg-white  rounded-xl border border-solid border-stone-200 border-solid">
            <div className="text-base leading-none">
              {t("profile.topUp.topUpAmount")}
            </div>
            <div className="flex justify-center gap-1.5 items-center self-start mt-3 text-xl font-bold w-full">
              <img
                loading="lazy"
                src={images.FlagImage}
                className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square"
                alt="Currency icon"
              />
              <div className="self-stretch my-auto">{topUpAmount} SGD</div>
            </div>
          </div>
        </>
      ),
      actions: (closeModal) => (
        <>
          <Button
            text={t("profile.topUp.newTopUp")}
            className="flex-1 border text-neutral-500"
            onClick={closeModal}
          />
          <Button
            text={t("base.home")}
            className="flex-1 bg-[#3F54DF] text-white"
            onClick={() => navigate("/")}
          />
        </>
      ),
    });
    modalRef.current?.openModal();
  };

  const handleConfirmTopUp = async () => {
    try {
      let isValid = true;
      const newErrors = { bankAccount: "", topUpAmount: "" };

      if (!bankAccount || bankAccount.trim() === "") {
        newErrors.bankAccount = t("profile.topUp.pleaseEnterBankAccount");
        isValid = false;
      }

      if (!topUpAmount || topUpAmount.trim() === "") {
        newErrors.topUpAmount = t("profile.topUp.pleaseEnterTopUpAmount");
        isValid = false;
      } else if (parseFloat(topUpAmount) <= 0) {
        newErrors.topUpAmount = t("profile.topUp.amountMustBeGreaterThanZero");
        isValid = false;
      }

      if (!isValid) {
        setError(newErrors);
        modalRef.current?.closeModal();
        return;
      }
      const response = await postTopUp({
        from_account: bankAccount,
        topup_amount: parseFloat(topUpAmount),
      }).unwrap();
      if (response?.status === 201) {
        confirmTopUp();
      } else {
        setError(t("profile.topUp.topUpFailed"));
      }
    } catch (error) {
      console.error("Top-up error:", error);
      setError(t("profile.topUp.topUpFailed"));
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col mx-auto w-full bg-neutral-50 max-w-[480px]">
      <Header
        backIcon={images?.BackIcon}
        title={t("profile.topUp.title")}
        onBackClick={handleBack}
      />
      <TimelineCommon steps={stepsData} />

      <div className="px-4">
        <div className="flex flex-col gap-3 p-3 mt-4 border-[#3F54DF] border-[1px] rounded-[10px]">
          <div className="text-base font-normal  text-[#787A7A]">
            <p>{t("topUp.topUpAmount")}</p>
          </div>
          <div className="flex flex-row gap-1.5">
            <img
              loading="lazy"
              src={images.FlagImage}
              className="object-contain w-4 aspect-square"
              alt="Currency icon"
            />
            <p className="text-xl font-bold">{topUpAmount} SGD</p>
          </div>
        </div>
        <Button
          onClick={openTopUpModal}
          text={t("profile.topUp.title")}
          className="w-full bg-[#3F54DF] text-white rounded-xl py-5"
        />
      </div>
      <CommonModal
        ref={modalRef}
        title={modalContent?.title}
        actions={modalContent?.actions}
      >
        {modalContent?.content}
      </CommonModal>
    </div>
  );
};

export default TopUp;
